import { useEffect, useRef } from 'react'

export function useScrollOnExpand(expanded) {
  const contentRef = useRef(null)

  useEffect(() => {
    if (!expanded) return undefined

    const frame = window.requestAnimationFrame(() => {
      const content = contentRef.current
      if (!content) return

      const bounds = content.getBoundingClientRect()
      const topMargin = 16
      const bottomMargin = 32
      const overflow = bounds.bottom - window.innerHeight + bottomMargin
      if (overflow <= 0) return

      // Reveal the bottom when it fits; keep the beginning visible for taller forms.
      const distance = Math.min(overflow, bounds.top - topMargin)
      if (distance <= 0) return

      window.scrollBy({
        top: distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      })
    })

    return () => window.cancelAnimationFrame(frame)
  }, [expanded])

  return contentRef
}
